<template>
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Revenue"
              bc1="App"
              bc2="Revenue"
              bc3="Summary"
          ></Breadcrumb>
        </div>
        <div
            class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
        >
        </div>
      </div>
      <div class="content-body">
        <section class="app-user-list">
          <div class="card">
            <h5 class="card-header">Search Filter</h5>
            <div class="d-flex  align-items-center mx-50 row pt-0 pb-2">
              <div class="col-lg-3 col-sm-12 ">
                <date-picker
                    v-model="startDate"
                    :disabledDate="disableFutureDates"
                    valueType="format"
                    :lang="lang"
                    name="toDate"
                    placeholder="choose starting date"
                ></date-picker>
              </div>
              <div class="col-lg-3 col-sm-12">
                <date-picker
                    v-model="endDate"
                    :disabledDate="disableFutureDates"
                    valueType="format"
                    :lang="lang"
                    name="fromDate"
                    placeholder="choose ending date"
                ></date-picker>
              </div>
              <div class="col-lg-3  col-sm-12">
                <button type="button" class="btn btn-primary"  @click="onSubmitFilters" >Search</button>
                <button type="button" class="ml-1 btn btn-danger " @click="clear" >Clear</button>
              </div>
            </div>


          </div>
          <div class="col-12 d-flex mt-3 mb-3  justify-content-center" v-if="filterLoader">
            <div class="spinner-border text-primary"></div>
          </div>
          <div class="card" v-show="!filterLoader">
            <div class="card-header d-flex">
              <h4 class="card-title">
                Charge Type Revenue
              </h4>
              <button type="button" class="btn btn-danger btn-sm" @click="$router.push({name:'revenue'})">back</button>
            </div>
           
            <div class="card-body" >
              <div class="row ">
                <div class="col-md-12 col-12">
                  <div class="card border-primary border-darken-4 badge-glow">
                    <div class="card-body">
                      <div class="row pb-2 ">
                        <div class="col-4 mt-2" v-for="(charge,chargeIndex) in chargeTypes" :key="chargeIndex">
                          <span @click="showChargeDetails(chargeIndex)" style="cursor: pointer"><strong>{{
                              charge.type
                            }}</strong> <span class="badge badge-pill badge-glow badge-light-warning">click to see details</span></span>
                          <br>
                          <span> <small class="text-info">vaultspay</small> {{
                              modifyAmount(parseFloat(charge.total / 100).toFixed(feesDecimalPlaces))
                            }} 	&nbsp;<span class="badge badge-light-success">{{ $route.params.currency }}</span></span>
                          </br>
                          <span> <small class="text-danger">gateway</small> {{
                              modifyAmount(parseFloat(charge.gatewayTotal / 100).toFixed(feesDecimalPlaces))
                            }}&nbsp;<span class="badge badge-light-success">{{ $route.params.currency }}</span></span>
                          </br>
                          <span> <small class="text-primary">revenue</small> {{
                              modifyAmount(parseFloat((charge.total - charge.gatewayTotal) / 100).toFixed(amountDecimalPlaces))
                            }} 	&nbsp;<span class="badge badge-light-success">{{ $route.params.currency }}</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 d-flex mt-3 mb-3  justify-content-center" v-if="chargesLoader">
                      <div class="spinner-border text-primary"></div>
                    </div>
              <div v-show="showDetails" v-else class="row ">
                <div class="col-md-12 col-12">
                  <h4 class="card-title">
                    Details
                  </h4>
                  <div class="card border-info border-darken-4 badge-glow">
                  
                    <div class="card-body" >
                      <div class="row pb-2 ">
                        <div class="col-4 mt-2" v-for="(chargesDetail,chargesDetailIndex) in chargesDetails"
                             :key="chargesDetailIndex">
                          <span><strong>{{ chargesDetail.name }}</strong> <span style="cursor: pointer"
                                                                                      @click="showAccounts(chargesDetailIndex)"
                                                                                      class="badge badge-pill badge-glow badge-light-primary">click to see accounts</span></span>
                          <br>
                          <span> <small class="text-info">vaultspay</small> {{
                              parseFloat(chargesDetail.total / 100).toFixed(feesDecimalPlaces)
                            }}	 &nbsp;<span
                                class="badge badge-light-success">{{ $route.params.currency }}</span></span>
                          </br>
                          <span> <small class="text-danger">gateway</small> {{
                              modifyAmount(parseFloat(chargesDetail.gatewayTotal / 100).toFixed(feesDecimalPlaces))
                            }} 	&nbsp;<span class="badge badge-light-success">{{ $route.params.currency }}</span></span>
                          </br>
                          <span>  <small class="text-primary">revenue</small> {{
                              modifyAmount(parseFloat((chargesDetail.total - chargesDetail.gatewayTotal) / 100).toFixed(amountDecimalPlaces))
                            }}	&nbsp;<span class="badge badge-light-success">{{ $route.params.currency }}</span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 d-flex mt-3 mb-3  justify-content-center" v-if="accountsLoader">
                      <div class="spinner-border text-primary"></div>
                    </div>
              <div class="row" v-show="showAccountsDetails" v-else>
                <div class="col-md-6 col-sm-12">
                  <div class="card">
                    <div class="card-header">
                      <div class="row w-100">
                        <div class="col-8">
                          <h4 class="card-title">Revenue From Sender</h4>
                        </div>
                        <div class="col-4 d-flex justify-content-end">
                          <input type="text" class="form-control" placeholder="search" v-model="searching">
                        </div>
                        <!--                        <h4 class="card-title">Sender Accounts Revenue</h4>-->

                      </div>
                    </div>
                    <div class="table-responsive table-hover-animation" style="max-height:  600px !important">
                      <table class="table">
                        <thead>
                        <tr>
                          <th>Name</th>
                          <th>Vp Total</th>
                          <th>Gateway Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(senderAccountItem,senderAccountIndex) in senderAccounts">
                          <td>
                            <div class="row">
                              <div class="col-md-6 col-sm-12">
                                <div class="font-weight-bold">{{ senderAccountItem.account }}</div>
                              </div>
                              <div class="col-md-6 col-sm-12" v-show="senderAccountItem.merchant">
                                <span class="badge badge-light-dark">Merchant</span>
                              </div>
                            </div>
                          </td>
                          <td>{{ modifyAmount(parseFloat(senderAccountItem.total / 100).toFixed(amountDecimalPlaces)) }}</td>
                          <td>{{ modifyAmount(parseFloat(senderAccountItem.gatewayTotal / 100).toFixed(amountDecimalPlaces)) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12">
                  <div class="card">
                    <div class="card-header">
                      <div class="row w-100">
                        <div class="col-8">
                          <h4 class="card-title">Revenue From Receiver</h4>
                        </div>
                        <div class="col-4">
                          <input type="text" placeholder="search" class="form-control" v-model="searchingReceiver">
                        </div>
                        <!--                        <h4 class="card-title">Sender Accounts Revenue</h4>-->

                      </div>
                    </div>
                    <div class="table-responsive table-hover-animation" style="max-height:  600px !important">
                      <table class="table">
                        <thead>
                        <tr>
                          <th>Name</th>
                          <th>Vp Total</th>
                          <th>Gateway Total</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(receiverAccountItem,receiverAccountIndex) in receiverAccounts">
                          <td>
                            <div class="row">
                              <div class="col-md-6 col-sm-12">
                                <div class="font-weight-bold">{{ receiverAccountItem.account }}</div>
                              </div>
                              <div class="col-md-6 col-sm-12" v-show="receiverAccountItem.merchant">
                                <span class="badge badge-light-dark">Merchant</span>
                              </div>
                            </div>
                          </td>
                          <td>{{ modifyAmount(parseFloat(receiverAccountItem.total / 100).toFixed(amountDecimalPlaces)) }}</td>
                          <td>{{ modifyAmount(parseFloat(receiverAccountItem.gatewayTotal / 100).toFixed(amountDecimalPlaces)) }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <section>
            <div class="row">
              <div class="col-sm-12">
                <div class="card">
<!--                  <div class="card-header">-->
<!--                    <h4 class="card-title">Accounts Details <span-->
<!--                        class="badge badge-light-success">{{ $route.params.currency }}</span></h4>-->
<!--                    <div class="col-md-6" >-->
<!--                      <SelectOptions-->
<!--                          label=""-->
<!--                          selectAppend="transaction type"-->
<!--                          labelValue="name"-->
<!--                          :modelValue.sync="selectedType"-->
<!--                          url="v1/transaction-types"-->
<!--                      />-->
<!--                      </div>-->
<!--                  </div>-->
                  <div v-if="tableLoad">
                    <div class="row mt-2">
                      <div class="col-12">
                        <div class="card" >
                          <LoadMoreCommonTable
                              :url="url"
                              :tableHeaderValues="tableHeaderValues"
                              :actions="actions"
                              :deleteActions="[]"
                              :mutedData="[]"
                              :storageKey="storageKey"
                              :externalTotalRecord="externalTotalRecord"
                              :filteredData="filteredData"
                              :loadMore="true"
                              :showPerPage="true"


                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>


        </section>
        <!-- users list ends -->

      </div>
    </div>
  </div>
</template>

<script>

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  props: ['currency'],
  components: {DatePicker},
  mounted() {
    this.sendCall()
    localStorage.setItem("url", "v1/revenue-summary");
    this.checkDataInStore('v1/revenue-summary')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
  },
  data() {
    return {
      tableLoad:false,
      filterLoader:false,
      chargesLoader:false,
      accountsLoader:false,
      startDate: "",
      endDate: "",
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
        monthBeforeYear: false,
      },
      selectedType: null,
      searching: '',
      searchingReceiver: '',
      currentChargeIndex: -1,
      receiverAccounts: [],
      senderAccounts: [],
      receiverAccountsCopy: [],
      senderAccountsCopy: [],
      userRoles: [],
      accounts: [],
      cards: [],
      chargeTypes: [],
      ledger: [],
      url: "v1/revenue-summary",
      storageKey: "revenue-summary",
      tableHeaderValues: [
        {
          title: "Transaction Id",
          valueKey: "transaction.uuid",
          html: true,
          alter: function (value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary"  style="cursor: pointer">${value}</span>`;

            } else {
              html = "-";
            }

            return html;
          },
          cta: (row) => {
            this.$router.push({name: 'transactions-detail', params: {id: row.transaction.uuid}})
          }
        },
        {
          title: 'Debit Amount',
          valueKey: 'debit_amount',
          html: true,
          alter: (value) => {
            var html = ''
            html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-danger">-</span>`
            }

            return html

          }
        },
        {
          title: 'Credit Amount',
          valueKey: 'credit_amount',
          html: true,
          alter: (value) => {
            var html = ''
            html = `<span style="font-size: larger" class=" font-weight-bolder text-success">${this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))}</span>`
            if ((value / 100) == 0) {
              html = `<span style="font-size: larger" class=" font-weight-bolder text-success">-</span>`
            }
            return html

          }
        },
        {
          title: 'Closing Balance',
          valueKey: 'closing_balance',
          alter: (value) => {
            return this.modifyAmount(parseFloat(value / 100).toFixed(this.amountDecimalPlaces))
          }
        },
        {
          title: 'Vat',
          valueKey: 'transaction.vat',
          html: true,
          alter: (value, row) => {
            var html = ''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>`


            return html
          }
        },
        {
          title: 'Fees',
          valueKey: 'transaction.fee',
          html: true,
          alter: (value, row) => {
            var html = ''

            html = ` <div  class="  text-dark">${parseFloat(value / 100).toFixed(this.feesDecimalPlaces)}</div>`


            return html

          }
        },
        {
          title: "Created Date / Time",
          valueKey: "created_at",
          alter: (value) => {
            return this.customFormatDateTime(value)
          }
        },
      ],
      actions: [],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      chargesDetails: [],
      // filteredData: {currencyId: this.$route.params.id, perPage: 40},
      filteredData: {currencyId: this.$route.params.id,ledger:1},
      chargeTypeFilteredData: {currencyId: this.$route.params.id},
      selectedCharge: -1,
      showDetails: false,
      showAccountsDetails: false
    }
  },
  methods: {
    onSubmitFilters() {
      let filterData = {currencyId: this.$route.params.id}

      if(this.startDate){
        filterData.startDate = this.startDate
      }
      if(this.endDate){
        filterData.endDate = this.endDate
      }

      this.chargeTypeFilteredData = filterData
      this.sendCall()

    },
    clear(){
      this.startDate = null
      this.endDate = null
      this.chargeTypeFilteredData = {currencyId: this.$route.params.id}
      this.sendCall()

    },

    async showAccounts(index) {

      this.accountsLoader = true
      let data = await this.getDetails({...this.chargeTypeFilteredData,chargeName:this.chargesDetails[index]['name']})
      
        this.receiverAccounts = this.receiverAccountsCopy  = data.accounts.receiverAccounts
        this.senderAccounts = this.senderAccountsCopy = data.accounts.senderAccounts
      this.showAccountsDetails = true

    },
    async showChargeDetails(index) {
  
      if (this.selectedCharge == index) {
    
          this.showDetails = !this.showDetails
        } else {
          this.selectedCharge = index
          this.chargesLoader = true
          this.chargesDetails =await this.getDetails({...this.chargeTypeFilteredData,chargeType:this.chargeTypes[index]['type']})
    
          this.showDetails = true
        }
        this.showAccountsDetails = false
    },
    async getDetails(payload) {
       let callResponse = await this.makeRequest('post', 'v1/revenue-summary', payload, {}, false)
       this.chargesLoader = false
       this.accountsLoader = false
     
     
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.senderAccounts = []
            this.receiverAccounts = []
            this.senderAccountsCopy = []
            this.receiverAccountsCopy = []
            return data

          }
        }
 

      return []

    },    
    sendCall() {
      this.filterLoader = true
      this.makeRequest('post', 'v1/revenue-summary', this.chargeTypeFilteredData, {}, false).then(callResponse => {
        this.filterLoader = false
        this.tableLoad = true
        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            this.showDetails = false
            this.showAccountsDetails = false
            this.senderAccounts = []
            this.receiverAccounts = []
            this.senderAccountsCopy = []
            this.receiverAccountsCopy = []
            this.chargeTypes = data.chargeTypeRevenue

          }
        }

      });

    },
  },
  watch: {
    searching(val) {
      if (val == '') {
        this.senderAccounts = this.senderAccountsCopy
      } else {
        let accountsCopy = this.senderAccountsCopy
        // let filteredData = accountsCopy.filter((obj) => obj['account'].toLowerCase() === val.toLowerCase())
        let filteredData = accountsCopy.filter(o => o.account.includes(val.toUpperCase()))
        this.senderAccounts = filteredData
      }

    },
    searchingReceiver(val) {
      if (val == '') {
        this.receiverAccounts = this.receiverAccountsCopy
      } else {
        let accountsCopy = this.receiverAccountsCopy
        // let filteredData = accountsCopy.filter((obj) => obj['account'].toLowerCase() === val.toLowerCase())
        let filteredData = accountsCopy.filter(o => o.account.includes(val.toUpperCase()))
        this.receiverAccounts = filteredData
      }

    },
    selectedType(val){

      let filterData = {currencyId: this.$route.params.id,ledger:1}

      // if(this.startDate){
      //   filterData.startDate = this.startDate
      // }
      // if(this.endDate){
      //   filterData.endDate = this.endDate
      // }


      if(val){
        this.filteredData = {
          ...filterData,
          currencyId: this.$route.params.id,
          transactionTypeId: val.id
        }
      }else{
        this.filteredData = {...filterData}
      }

    },


  }

}
</script>


